import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h2>Seamless Implementation of Our Telehealth Solutions</h2>
            <p>
              Telehealth solutions are revolutionizing healthcare delivery
              across various domains. They break down geographical barriers,
              ensuring patients can access care irrespective of location while
              enhancing collaboration among healthcare teams, thereby improving
              overall efficiency.
            </p>
            <p>
              Moreover, telehealth extends to mental health, chronic disease
              management, and preventive care, empowering patients to manage
              conditions effectively and promoting proactive health monitoring
              and education for healthier lifestyles.
            </p>
            <p>
              Here are the domains of the healthcare sector where we can
              implement our telehealth solutions:
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Custom Solution
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-lg-3 offset-md-3  my-auto"
          >
            <div className="industry_scroll">
              <h3>Telehealth for nursing care</h3>
              <h3>Telehealth for physical therapy</h3>
              <h3>Telemedicine for pediatrics</h3>
              <h3>Telemedicine in rural areas</h3>
              <h3>Telemedicine in primary care</h3>
              <h3>Telemedicine for mental health</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industryusa;
